var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var AiCIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 58
  }), React.createElement("path", {
    d: "M28.7951 51.1919C16.4478 51.1919 6.39827 41.1424 6.39827 28.7951C6.39827 16.4478 16.4478 6.39827 28.7951 6.39827C34.9688 6.39827 40.5665 8.9092 44.6266 12.9636L49.1475 8.44272C43.9356 3.23081 36.7368 0 28.7951 0C12.9175 0 0 12.9175 0 28.7951C0 44.6727 12.9175 57.5902 28.7951 57.5902C36.7368 57.5902 43.9356 54.3594 49.1475 49.1475L44.6266 44.6266C40.5723 48.681 34.9745 51.1919 28.7951 51.1919Z"
  }), React.createElement("path", {
    d: "M28.7951 38.3957C23.5026 38.3957 19.1948 34.088 19.1948 28.7954C19.1948 23.5029 23.5026 19.1951 28.7951 19.1951C31.4443 19.1951 33.84 20.2721 35.5793 22.0113L40.1001 17.4905C37.2033 14.5937 33.2065 12.7969 28.7951 12.7969C19.9723 12.7969 12.7966 19.9726 12.7966 28.7954C12.7966 37.6183 19.9723 44.794 28.7951 44.794C33.2065 44.794 37.2033 42.9972 40.1001 40.1004L35.5793 35.5796C33.84 37.3188 31.4443 38.3957 28.7951 38.3957Z"
  }), React.createElement("path", {
    d: "M47.8748 12.9346C47.8748 21.838 40.653 29.0598 31.7495 29.0598C40.653 29.0598 47.8748 36.2816 47.8748 45.1851C47.8748 36.2816 55.0966 29.0598 64 29.0598C55.0966 29.0598 47.8748 21.838 47.8748 12.9346ZM47.8748 32.1697C46.9533 31.0294 45.9109 29.987 44.7649 29.0598C45.9052 28.1384 46.9476 27.096 47.8748 25.95C48.7962 27.0902 49.8386 28.1326 50.9846 29.0598C49.8444 29.9813 48.802 31.0237 47.8748 32.1697Z"
  }), React.createElement("path", {
    d: "M52.9427 19.4422C55.4882 19.4422 57.5499 21.5039 57.5499 24.0494C57.5499 21.5039 59.6116 19.4422 62.1571 19.4422C59.6116 19.4422 57.5499 17.3804 57.5499 14.835C57.5499 17.3804 55.4882 19.4422 52.9427 19.4422Z"
  }));
};
export var AiCIconGlyph = function (props) {
  return React.createElement(AiCIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};